import { instance } from "./axios";
import * as actions from "../../actionTypes";
// import { BUSINESS_ACTIVITIES, LEGAL_FORMS } from "../appReducer";
import { authHeader } from "../../../helpers/authHeader";
import { homeHeatingOptions } from "../../../shared/const/data";

const POST_HARP_APPLICATION = "POST_HARP_APPLICATION";
const POST_HARP_APPLICATION_SUCCESS = "POST_HARP_APPLICATION_SUCCESS";
const POST_HARP_APPLICATION_FAILURE = "POST_HARP_APPLICATION_FAILURE";

const baseURL = process.env.REACT_APP_SERVICE_URL;

const initialState = {
  confirmationId: null,
  harpApplicationId: null,
  error: null,
  pdf: null
};

// Reducer

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case POST_HARP_APPLICATION_SUCCESS:
      return {
        ...state,
        error: null,
        confirmationId: action.payload.confirmationId,
        harpApplicationId: action.payload.harpApplicationId,
        pdf:action.payload.pdf
      };
    case POST_HARP_APPLICATION:
      return initialState;
    case POST_HARP_APPLICATION_FAILURE:
      return {
        ...initialState,
        error: "errors.grant_application_sent_failure"
      };
    case actions.CLEAR_ALL: {
      return initialState;
    }
    default:
      return state;
  }
};

/*
const formatHarpApplicationData = (appData) => {
  const {
    personalInformation,
    otherAdultInformation,
    homeAddress,
    mailingAddress,
    questionDataList,
    authorizeCanadaRevenueAgency,
    cyberSecurity,
    applicantSignature,
    otherApplicantSignature,
    appLanguage
  } = appData;
  const residentialQuestion =
    questionDataList[
      questionDataList.findIndex((question) => question?.questionNumber === 5)
    ]?.questionAnswer;
  const filterQuestionList = questionDataList.filter((question) => {
    return question.questionAnswer !== "" && question?.flag !== false;
  });

  const mailingAddressData = mailingAddress;
  const livingArrangement = residentialQuestion;
  const applicantData = {
    applicant: {
      firstName: personalInformation.firstName,
      lastName: personalInformation.lastName,
      dob: new Date(personalInformation.dateOfBirth)
        .toISOString()
        .split("T")[0],
      sinNumber: personalInformation.socialInsuranceNumber?.replace(/ /g, ""),
      emailAddress: personalInformation.email,
      homePhoneNumber: personalInformation.phone?.replace(/-/g, ""),
      consent: true,
      otherPhoneNumber: personalInformation.altPhone?.replace(/-/g, "")
    },
    otherPersonInformation: {
      firstName: otherAdultInformation.firstName,
      lastName: otherAdultInformation.lastName,
      sinNumber: otherAdultInformation.socialInsuranceNumber?.replace(/ /g, ""),
      dob: otherAdultInformation.dateOfBirth
        ? new Date(otherAdultInformation.dateOfBirth)
            ?.toISOString()
            .split("T")[0]
        : null,
      consent: otherAdultInformation?.firstName ? true : ""
    },
    signatureApplicant: applicantSignature?.substring(
      applicantSignature.indexOf(",") + 1
    ),
    signatureOtherPerson: otherApplicantSignature?.substring(
      applicantSignature.indexOf(",") + 1
    ),
    declarationAttestationComplete: true,
    authorizeCanadaRevenueAgency:
      authorizeCanadaRevenueAgency === true ? true : false,
    allPeopleAgreeStatement: true,
    // cyberSecurityCanContactMe: cyberSecurity,
    residentialStatus: livingArrangement,
    applicantConsentforFutureResearchStudies:
      cyberSecurity === true ? true : null,
    civnid: homeAddress.civicId,
    language: appLanguage,
    householdAddress: {
      street: homeAddress.apartment
        ? `${homeAddress.apartment}-${homeAddress.streetAddress}`
        : `${homeAddress.streetAddress}`,
      city: homeAddress.city,
      provinceState: "NS",
      country: "Canada",
      postalCode: homeAddress.postalCode,
      phoneNumber: personalInformation.phone?.replace(/-/g, "")
    },
    mailingAddress: {
      street: mailingAddressData.street
        ? mailingAddressData.street
        : homeAddress.apartment
        ? `${homeAddress.apartment}-${homeAddress.streetAddress}`
        : `${homeAddress.streetAddress}`,
      city: mailingAddressData.street
        ? mailingAddressData.city
        : homeAddress.city,
      provinceState: "NS",
      country: "Canada",
      postalCode: mailingAddressData.street
        ? mailingAddressData.postalCode
        : homeAddress.postalCode,
      phoneNumber: personalInformation.phone?.replace(/-/g, "")
    },
    questionList: filterQuestionList
  };

  if (
    otherAdultInformation.firstName === "" ||
    otherAdultInformation.firstName === null
  ) {
    console.log("empty other adult");
    delete applicantData["otherPersonInformation"];
  }

  return applicantData;
};
*/

export const postHarpApplicationAPIAction = (appData, language) => {
  return (dispatch) => {
    const data = getRequestData(appData, language);

    dispatch({ type: POST_HARP_APPLICATION });
    return instance
      .post(
        `${baseURL}harp/submit?language=${appData.appLanguage}`,
        data,
        //config
        {
          headers: Object.assign(
            { "Content-Type": "application/json" },
            authHeader()
          )
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("200");
            dispatch({
              type: POST_HARP_APPLICATION_SUCCESS,
              payload: {
                confirmationId: response["data"]["confirmationNumber"],
                harpApplicationId: response["data"]["harpApplicationId"],
                pdf: response['data']['pdfDto']
              }
            });
            return response["data"];
            // return response["data"]["amandaReturnValue"];
          } else {
            console.log("FAILURE");
            dispatch({ type: POST_HARP_APPLICATION_FAILURE });
          }
        },
        (err) => {
          console.log(err);
          if (err === 409) {
            console.log("Duplicate Application");
            dispatch({ type: POST_HARP_APPLICATION_FAILURE });
            return 409;
          } else {
            dispatch({ type: POST_HARP_APPLICATION_FAILURE });
            // throw new Error(`Error in getting services`)
            return null;
          }
        }
      );
  };
};

export const getHarpApplicationPDF = async (
  confirmationId,
  applicationType
) => {
  return instance.get(
    `${baseURL}create/pdf?confirmationNumber=${confirmationId}&applicationType=${applicationType}`,
    //config
    {
      headers: Object.assign(
        { "Content-Type": "application/json" },
        authHeader()
      )
    }
  );
};

function getRequestData(appData, language) {
  const requestData = {};

  const personalInfo = appData.personalInformation;

  const mainApplicantPerson = {
    firstName: personalInfo.firstName,
    surname: "",
    lastName: personalInfo.lastName,
    dob: new Date(personalInfo.dateOfBirth).toISOString().split("T")[0],
    sin: personalInfo.socialInsuranceNumber?.replace(/\s/g, ""),
    signature: appData.applicantSignature?.substring(
      appData.applicantSignature?.indexOf(",") + 1
    )
  };
  requestData["mainApplicantPerson"] = mainApplicantPerson;

  const otherAdultsInformation = appData.otherAdultsInformation;
  const findAssessmentDoc = (id) => {
    for (let key in appData.otherAdultAssessmentFiles) {
      if (key == id) {
        return appData.otherAdultAssessmentFiles[key][0].name
      }
    }
  }
  let otherAdultInfo;
  if (otherAdultsInformation && otherAdultsInformation[0].firstName) {
    otherAdultInfo = otherAdultsInformation?.map((otherAdult) => {
      const signature = appData.otherAdultsSignature[otherAdult.localId];
      return {
        firstName: otherAdult.firstName,
        surname: "",
        lastName: otherAdult.lastName,
        dob: new Date(otherAdult.dateOfBirth).toISOString().split("T")[0],
        sin: otherAdult?.socialInsuranceNumber?.replace(/\s/g, ""),
        signature: signature?.substring(signature?.indexOf(",") + 1),
        ...findAssessmentDoc(otherAdult.localId) && { noticeOfAssessment: findAssessmentDoc(otherAdult.localId) }
      };
    });
  }
  // ---------------- Modifying the payload of other Applicants as per BE requirement -------------------------
  if (otherAdultInfo) {
    requestData["otherApplicantPerson"] = otherAdultInfo[0];
    requestData["thirdApplicantPerson"] = otherAdultInfo[1];
    requestData["extraApplicantPersonList"] = otherAdultInfo.splice(2)
  }

  // ------------------------------------------------------------------------------------------------------------------
  const homeAddress = appData.homeAddress;
  const civicAddress = {
    civicNumberId: homeAddress.civicId,
    streetAddress: homeAddress.streetAddress,
    unit: homeAddress.apartment,
    city: homeAddress.city,
    provinceTerritory: homeAddress.province,
    postalCode: homeAddress.postalCode
  };
  requestData["civicAddress"] = civicAddress;

  const mailingAddress = appData.mailingAddressSame
    ? civicAddress
    : appData.mailingAddress;

  const mailingAddressData = {
    civicNumberId: mailingAddress.civicNumberId,
    streetAddress: mailingAddress.street ? mailingAddress?.street : mailingAddress?.streetAddress ,
    unit: mailingAddress.unit,
    city: mailingAddress.city,
    provinceTerritory: mailingAddress.provinceState ? mailingAddress?.provinceState : mailingAddress?.provinceTerritory,
    postalCode: mailingAddress.postalCode
  };

  requestData["mailingAddress"] = mailingAddressData;
  requestData["emailAddress"] = personalInfo.email;
  requestData["phoneNumber"] = personalInfo?.phoneNumber?.replace(/-/g, '');
  requestData["alternatePhoneNumber"] = personalInfo?.altPhone?.replace(/-/g, '');
  requestData["textingAvailable"] = personalInfo.textAllowedAtPhoneNumber;
  requestData["ownRentHome"] = appData.houseOwnOrRent;

  // --------------------------------------------------------- Additional fields for Amanda --------------------------------------------------------------------------------
  function fetchIncomeType(a, b, c) {
    if (appData.questionDataList.find((x => x.questionNumber == a)).questionAnswer === 'Yes') {
      return 'DCS_INCOME_ASSISTANCE'
    } else if (appData.questionDataList.find((x => x.questionNumber == b)).questionAnswer === 'Yes') {
      return 'GIS_SENIOR'
    } else {
      let houseHoldType = appData.questionDataList.find((x => x.questionNumber == 8)).questionAnswer
      if (houseHoldType === 'Single with no kids') {
        return 'SINGLE'
      } else if (houseHoldType === 'Single parent') {
        return 'SINGLE_PARENT'
      } else {
        return 'MULTI_ADULT'
      }
    }
  }

  requestData["incomeType"] = fetchIncomeType(3,6,8) || ''

  // -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  const heatingProofUpload = getHeatingProofUploadSelection(
    appData.questionDataList
  );
  requestData["wantToUploadProofheating"] = heatingProofUpload;

  requestData["heatingSourceType"] = getHomeHeatingSourceType(
    appData.questionDataList,
    language
  )?.toUpperCase();
  requestData["contactedByEfficiencyNS"] = appData.contactedByEfficiency;
  requestData["contactedByDepartmentCyberSecurity"] = appData.cyberSecurity;
  requestData["attachmentList"] = getFileAttachments(
    appData,
    heatingProofUpload
  );
  requestData["consentForFeedback"] = appData.cyberSecurity;

  requestData["questionAnswerList"] = getQuestionAnswerList(
    appData.questionDataList,
    language
  );
  requestData.phoneNumber = personalInfo.phone.replace(/-/g, '')

  return requestData;
}

function getQuestionAnswerList(questionDataList, language) {
  let questionList = [];

  questionDataList?.forEach((questionData) => {
    if (questionData.questionAnswer) {
      const q = {
        questionNumber: questionData.questionNumber,
        question:
          language === "fr"
            ? questionData?.questionFrench
              ? questionData.questionFrench
              : questionData.question
            : questionData.question,
        answer: language === "fr" ? questionData?.questionAnswerFrench : questionData.questionAnswer
      };
      questionList.push(q);
    }
  });
  questionList = questionList.filter((x => x.questionNumber !== 16 && x.questionNumber !== 14 && x.questionNumber !== 13 && x.questionNumber !== 15))
  return questionList;
}

function getHomeHeatingSourceType(questionDataList, language) {
  const appliedHomeHeating =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 13)
    ].questionAnswer;



  return appliedHomeHeating
}

function getHeatingProofUploadSelection(questionDataList, language) {
  return questionDataList[
    questionDataList.findIndex((question) => question.questionNumber === 14)
  ].flag;
}

function getFileAttachments(appData, heatingProofUpload) {
  const otherAdultsNOA = appData.otherAdultAssessmentFiles;
  const filesArr = [];

  if (otherAdultsNOA && Object.keys(otherAdultsNOA).length) {
    for (const key in otherAdultsNOA) {
      if (Object.hasOwnProperty.call(otherAdultsNOA, key)) {
        const fileData = otherAdultsNOA[key][0];
        const file = {
          attachmentType: "HARP_NOA",
          attachmentName: fileData.name,
          content: fileData.data,
          // formattedFileSize: fileData.size,
          // mimeType: fileData.type
        };
        filesArr.push(file);
      }
    }
  }

  const heatingBill = appData.heatingBill;
  if (heatingBill && heatingBill.length) {
    heatingBill.map((fileData) => {
      const file = {
        attachmentType: "HARP_BILL",
        attachmentName: fileData.name,
        content: fileData.data,
        // formattedFileSize: fileData.size,
        // mimeType: fileData.type
      };
      filesArr.push(file);
      return;
    });
  }

  return filesArr;
}
